import { Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import Home from '@/pages/Home';
import Routes_ from '@/pages/Routes';
import Booking from '@/pages/Booking';
import Fleet from '@/pages/Fleet';
import TravelGuide from '@/pages/TravelGuide';
import TwigaMiles from '@/pages/TwigaMiles';
import Cargo from '@/pages/Cargo';
import About from '@/pages/About';
import News from '@/pages/News';
import Contact from '@/pages/Contact';
import NotFound from '@/pages/not-found/Index';

export default function App() {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.HOME} element={<Home />} />
      <Route path={ROUTE_PATHS.ROUTES} element={<Routes_ />} />
      <Route path={ROUTE_PATHS.BOOKING} element={<Booking />} />
      <Route path={ROUTE_PATHS.FLEET} element={<Fleet />} />
      <Route path={ROUTE_PATHS.TRAVEL_GUIDE} element={<TravelGuide />} />
      <Route path={ROUTE_PATHS.TWIGA_MILES} element={<TwigaMiles />} />
      <Route path={ROUTE_PATHS.CARGO} element={<Cargo />} />
      <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
      <Route path={ROUTE_PATHS.NEWS} element={<News />} />
      <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
